"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@remirror/react");
const Button_1 = __importDefault(require("../../../../ui/Button/Button"));
const FormatListNumbered_1 = __importDefault(require("@mui/icons-material/FormatListNumbered"));
const OrderedListButton = () => {
    const { toggleOrderedList } = (0, react_2.useCommands)();
    const chain = (0, react_2.useChainedCommands)();
    const active = (0, react_2.useActive)();
    const enabled = toggleOrderedList.enabled();
    const handleSelect = () => {
        if (toggleOrderedList.enabled()) {
            chain.toggleOrderedList().focus().run();
        }
    };
    return (react_1.default.createElement(Button_1.default, { handleOnClick: handleSelect, isDisabled: !enabled, isActive: active.orderedList(), icon: react_1.default.createElement(FormatListNumbered_1.default, null), label: "Ordered list" }));
};
exports.default = OrderedListButton;
